export const getCellSx = (column, selectedCol) => ({
  padding: '4px 6px',
  background: '#fff',
  color: '#A9A9A9',
  height: '54px',
  cursor: column.handleClick ? 'pointer' : 'default',
  img: column.handleClick
    ? {
        filter: column.propName === selectedCol ? null : 'invert(60%)',
      }
    : null,

  width: column.width ?? null,
})
